import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Alert, Button, Flex } from 'antd';
import { i18n } from './i18n';
interface ErrorBoundaryProps {
  children: ReactNode;
}
interface ErrorBoundaryState {
  error: Error | null;
}
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null };
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }
  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[ErrorBoundary] render crashed:', error, info.componentStack);
  }
  private readonly reload = (): void => {
    window.location.reload();
  };
  override render(): ReactNode {
    const { error } = this.state;
    if (error === null) return this.props.children;
    return (
      <Flex align="center" justify="center" style={{ minHeight: '60vh', padding: 24 }}>
        <Alert
          type="error"
          showIcon
          message={i18n.t('errors.unknown')}
          description={error.message}
          action={
            <Button size="small" onClick={this.reload}>
              {i18n.t('common.refresh')}
            </Button>
          }
        />
      </Flex>
    );
  }
}
